import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { getFinishDateForSchoolYear } from 'Src/helpers/calendar/calendar';
import { School } from 'Src/models/school';
import { UnionSchoolReportForm } from '../UnionSchoolReportForm';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; school: School; }

export function SchoolTournamentScheduleUnionSideReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  return <UnionSchoolReportForm
    initialValues={{ dateFrom: now, dateTo: getFinishDateForSchoolYear(now), isShowBooked: true, isShowWaitingList: true, isShowRemoved: false, isShowOtherUnionTournaments: false }}
    reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.SCHOOL_TOURNAMENT_SCHEDULE_UNION_SIDE}
    description="Review the selected school’s tournament bookings, waiting-list places and previous removals for the chosen period."
    showAudience={false}
    toggles={[
      { field: 'isShowBooked', label: 'Participating tournaments', hint: 'Include tournaments where the school has a confirmed place.' },
      { field: 'isShowWaitingList', label: 'Waiting-list tournaments', hint: 'Include tournaments where the school is waiting for a place.' },
      { field: 'isShowRemoved', label: 'Removed tournaments', hint: 'Include tournaments from which the school was removed.' },
      { field: 'isShowOtherUnionTournaments', label: 'Other unions’ tournaments', hint: 'Include tournaments organised by unions other than the current union.' }
    ]}
    onCloseClick={onCloseClick}
    onSubmit={onSubmit}
  />;
}
